import React from "react";
import "./KeyAdvantages.css";
import KeyAdvantageCard from "./KeyAdvantageCard";

const cardData = [
  {
    icon: "/assets/img/Discover_with_ease_Black.png",
    title: "Discover with ease",
    subtitle: "Compare Pre-qualified offers from  lenders",
  },
  {
    icon: "/assets/img/Snag_instant_savings_Black.png",
    title: "Snag instant savings",
    subtitle: "Select offers with lowest interest rates and processing",
  },
  {
    icon: "/assets/img/Fast_Simple_Digital_black.png",
    title: "Fast. Simple. Digital.",
    subtitle: "4-step process to instant approval & transfer",
  },
  {
    icon: "/assets/img/No_Hidden_Costs_Ever_Black.png",
    title: "No Hidden Costs, Ever",
    subtitle:
      "No hidden charges, no surprises—just honest information, always.",
  },
];

const KeyAdvantages = () => {
  return (
    <div className="key-advantage-section1-v3">
      <div className="advantage-header">
        <h3 className="advantage-title_v3">Key Advantages</h3>
        <p className="advantage-subtext_v3">
          We value your trust-Simple, fast, and reliable personal loans.
        </p>
      </div>
      <div className="advantage-grid1">
        {cardData.map((card, index) => (
          <KeyAdvantageCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default KeyAdvantages;
